(function($, bc, undefined) {

	"use strict";

	/**
	 * @class Paragraphs
	 */
	class Paragraphs {

		/**
		 * Creates an instance of Paragraphs
		 */
		constructor() {
			// setup:
			this.setup();
		} /* constructor */

		setup() {

			// text content blocks:
			//new bc.TextContent();

			// slider:
			//new bc.Slider();

			// lazy load images:
			new bc.LazyLoads();

			// image gallery:
			//new bc.ImageGallery();

			// video:
			//new bc.Video();

			// image popup:
			//new bc.ImagePopup();

			// block links:
			//new bc.ParagraphBlockLinks();

			// productdb reference block:
			//new bc.ProductdbReferenceBlock();

		} /* setup */

	} /* Paragraphs */

	bc.Paragraphs = Paragraphs;

})(jQuery, window.bc = window.bc || {});
